import { email, greaterThan, packValidateResults, required } from 'helpers/validators';
import { TopUpBalanceFieldProps } from 'services/API/TopUpBalance/interface';

export const validate = (data: TopUpBalanceFieldProps) =>
  packValidateResults([
    required(data, ['amount', 'store_id', 'email']),
    greaterThan(data, ['amount'], { gt: 0 }),
    email(data, ['email']),
  ]);
